import { classicNavy } from './classicNavy';
import { modernTeal } from './modernTeal';
import { slateExecutive } from './slateExecutive';

export const themes = {
  'classic-navy': classicNavy,
  'modern-teal': modernTeal,
  'slate-executive': slateExecutive,
};

export const defaultThemeId = 'classic-navy';

export function getTheme(themeId) {
  return themes[themeId] || themes[defaultThemeId];
}
